export const build = { date:"2026-05-06.1646", stage:"alpha" }
